/**
 * The media-kind names and the STORY cadence sentence every cadence card
 * reads (`../pages/profile/`), kept in one catalogue so the profile editor,
 * the add-account dialog and the tracking editor name the kinds alike.
 */

import { defineCatalogue } from '../../../i18n';

export const cardsCatalogue = defineCatalogue(
  {
    'kind.POST': 'Publicações',
    'kind.REEL': 'Reels',
    'kind.STORY': 'Stories',
    'kind.AUDIO': 'Áudio',
    'story.sentence': 'A cada {interval}.',
  },
  {
    'kind.POST': 'Posts',
    'kind.REEL': 'Reels',
    'kind.STORY': 'Stories',
    'kind.AUDIO': 'Audio',
    'story.sentence': 'Every {interval}.',
  },
);
